import { render, staticRenderFns } from "./FormList.vue?vue&type=template&id=4bd5aaed&scoped=true"
import script from "./FormList.vue?vue&type=script&lang=js"
export * from "./FormList.vue?vue&type=script&lang=js"
import style0 from "./FormList.vue?vue&type=style&index=0&id=4bd5aaed&prod&lang=scss"
import style1 from "./FormList.vue?vue&type=style&index=1&id=4bd5aaed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd5aaed",
  null
  
)

export default component.exports